import React, { useState } from 'react';
import { Box, Typography, Button, CircularProgress, IconButton, Stack } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { MuiOtpInput } from 'mui-one-time-password-input';

interface OTPVerificationProps {
  onVerify: (otp: string) => Promise<void>;
  onBack: () => void;
  isLoading: boolean;
}

const OTPVerification: React.FC<OTPVerificationProps> = ({ onVerify, onBack, isLoading }) => {
  const [otp, setOtp] = useState('');
  const [error, setError] = useState('');

  const handleVerify = async () => {
    if (otp.length !== 4) {
      setError('Please enter a 4-digit code');
      return;
    }

    setError('');
    await onVerify(otp);
  };

  const handleChange = (value: string) => {
    // Only allow numbers and max 4 digits
    const cleaned = value.replace(/\D/g, '').slice(0, 4);
    setOtp(cleaned);
    setError('');
  };

  return (
    <Box sx={{ p: 3, overflowY: 'auto', flex: 1 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
        <IconButton
          onClick={onBack}
          disabled={isLoading}
          sx={{ mr: 1, p: 0.5 }}
          aria-label="Go back"
        >
          <ArrowBackIcon />
        </IconButton>
        <Typography variant="h6" fontWeight={600}>
          Verify your number
        </Typography>
      </Box>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        We've sent a verification code to your phone.
      </Typography>

      {/* <TextField
        fullWidth
        label="Enter 4-digit code"
        value={otp}
        onChange={(e) => handleChange(e.target.value)}
        error={!!error}
        helperText={error}
        disabled={isLoading}
        inputProps={{
          maxLength: 4,
          inputMode: 'numeric',
          pattern: '[0-9]*',
        }}
        sx={{ mb: 3 }}
      /> */}

      <Stack direction='column' spacing={2} alignItems='center' mt={3}>
        <MuiOtpInput
          value={otp}
          onChange={(value) => handleChange(value)}
          length={4}
          autoFocus
          validateChar={(char) => /^[0-9]$/.test(char)}
          sx={{
            display: 'flex',
            gap: '10px',
            justifyContent: 'center',
          }}
          TextFieldsProps={{
            inputProps: {
              inputMode: 'numeric',
              type: 'tel',
            },
            sx: {
              width: '54px',
              height: '54px',
              input: {
                textAlign: 'center',
                fontSize: '18px',
                backgroundColor: '#EDF1F7',
                borderRadius: '12px',
              },
              '& .MuiOutlinedInput-root': {
                '& fieldset': {
                  border: 'none',
                },
                '&:hover fieldset': {
                  border: 'none',
                },
                '&.Mui-focused fieldset': {
                  border: 'none',
                },
              },
            },
          }}
        />

        {!!error && (
          <Typography variant='caption' color='error'>
            {error}
          </Typography>
        )}
      </Stack>

      <Button
        fullWidth
        variant="contained"
        onClick={handleVerify}
        //disabled={isLoading || otp.length !== 4}
        sx={{
          mt: 3,
          py: 1.5,
          color: "#ffffff",
          background: 'linear-gradient(135deg, #1976d2 0%, #1565c0 100%)',
        }}
      >
        {isLoading ? <CircularProgress size={24} sx={{ color: "#ffffff" }} /> : 'Verify'}
      </Button>
    </Box>
  );
};

export default OTPVerification;
